import * as React from 'react';
import { Component, deps, inject, observer } from '../../lib/component';
import {BrandSponsoredLabel} from '../brand-sponsored-label';

export interface BrandSponsoredLabelCompatProps {
  className?: string;
  expanded?: boolean;
}

@inject(deps) @observer
export class BrandSponsoredLabelCompat extends Component<BrandSponsoredLabelCompatProps> {
  render() {
    // TODO remove after prod deploy
    const licenceTooltipContent = `This song is available for use in Brand Sponsored content, from just $80. This means if you're being paid to make a promotional video on-behalf of a brand you can license this song legally for use in your video.`;

    const i18n = {
      ...BrandSponsoredLabel.i18n,
      title: licenceTooltipContent
    };

    return (
      <BrandSponsoredLabel i18n={i18n} {...this.props}/>
    )
  }
}